import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'
import {
	getUserSuccess,
	setUserTeamApprovalSettingsFailure,
	setUserTeamApprovalSettingsSuccess,
} from 'redux/user/reducer'
import { IUser, IUserTeamApprovalSettingsPayload } from './types'

export function* setUserTeamApprovalSettings({ payload }: PayloadAction<IUserTeamApprovalSettingsPayload>) {
	try {
		const {
			data,
			message,
		}: {
			data: { user: IUser }
			message: string
		} = yield call(apiMiddleware, {
			url: app_config.services.updateTeamApprovalSettings,
			method: 'POST',
			data: payload,
		})

		yield put(getUserSuccess(data.user))
		yield put(setUserTeamApprovalSettingsSuccess())

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(setUserTeamApprovalSettingsFailure())
	}
}
